<template>
  <div class="third-party-call-record">
    <div class="container">
      <h1>三方调用记录查阅</h1>

      <!-- 搜索条件 -->
      <div class="filter-section">
        <el-form :model="searchForm" label-position="right">
          <el-row :gutter="15">
            <el-col :span="6">
              <el-form-item label="商城编码" label-width="80px">
                <el-input v-model="searchForm.storeCode" placeholder="请输入商城编码" clearable />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="三方接口编码" label-width="100px">
                <el-input v-model="searchForm.thirdInterfaceCode" placeholder="请输入接口编码" clearable />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="业务类型" label-width="80px">
                <el-select v-model="searchForm.bizType" placeholder="请选择" style="width: 100%">
                  <el-option
                    v-for="item in bizTypeList"
                    :key="item.id"
                    :label="item.itemText"
                    :value="item.itemValue"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="验签状态" label-width="80px">
                <el-select v-model="searchForm.verifySignState" placeholder="请选择" clearable style="width: 100%">
                  <el-option label="全部" value="" />
                  <el-option label="通过" value="pass" />
                  <el-option label="失败" value="fail" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15" style="margin-top: 10px">
            <el-col :span="6">
              <el-form-item label="完成状态" label-width="80px">
                <el-select v-model="searchForm.finishState" placeholder="请选择" clearable style="width: 100%">
                  <el-option label="全部" value="" />
                  <el-option
                    v-for="item in finishStateList"
                    :key="item.id"
                    :label="item.itemText"
                    :value="item.itemValue"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          <el-col :span="12">
            <el-form-item label="时间范围" label-width="80px">
              <el-date-picker
                clearable
                :default-time="['00:00:00', '23:59:59']"
                v-model="searchForm.timeRange"
                type="datetimerange"
                align="right"
                start-placeholder="请选择开始时间"
                end-placeholder="请选择结束时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
            <el-col :span="6" style="text-align: right">
              <el-button type="primary" @click="handleSearch">查询</el-button>
              <el-button @click="handleReset">重置</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <!-- 数据表格 -->
      <el-table :data="tableData" border style="width: 100%; margin-top: 20px">
        <el-table-column prop="storeCode" label="商城编码" min-width="140" />
        <el-table-column prop="thirdInterfaceCode" label="接口编码" min-width="120" />
        <el-table-column prop="bizType" label="业务类型" min-width="120">
          <template slot-scope="scope">
            {{ formatBizType(scope.row.bizType) }}
          </template>
        </el-table-column>
        <el-table-column label="验签状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="getVerifySignStateType(scope.row.verifySignState)">
              {{ formatVerifySignState(scope.row.verifySignState) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="完成状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="getFinishStateType(scope.row.finishState)">
              {{ formatFinishState(scope.row.finishState) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="callbackTime" label="回调时间" min-width="160" />
        <el-table-column prop="finishTime" label="完成时间" min-width="160" />
        <el-table-column label="操作" width="100" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="handleViewDetail(scope.row)">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        class="pagination"
        background
        layout="prev, pager, next, jumper, ->, total"
        :total="pagination.total"
        :page-size="pagination.pageSize"
        :current-page="pagination.pageNo"
        @current-change="handlePageChange"
      />
    </div>

    <!-- 详情弹窗 -->
    <el-dialog
      title="调用记录详情"
      :visible.sync="detailDialogVisible"
      width="60%"
      :close-on-click-modal="true"
    >
      <div v-if="currentRow" class="detail-content">
        <!-- 基本信息 -->
        <div class="detail-section">
          <h3>基本信息</h3>
          <el-row :gutter="20">
            <el-col :span="12">
              <div class="detail-item">
                <span class="detail-label">商城编码:</span>
                <span class="detail-value">{{ currentRow.storeCode || '-' }}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="detail-item">
                <span class="detail-label">跟踪ID:</span>
                <span class="detail-value">{{ currentRow.traceId || '-' }}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="detail-item">
                <span class="detail-label">接口类型:</span>
                <span class="detail-value">{{ currentRow.interfaceType || '-' }}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="detail-item">
                <span class="detail-label">三方接口编码:</span>
                <span class="detail-value">{{ currentRow.thirdInterfaceCode || '-' }}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="detail-item">
                <span class="detail-label">业务类型:</span>
                <span class="detail-value">{{ formatBizType(currentRow.bizType) }}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="detail-item">
                <span class="detail-label">验签状态:</span>
                <span class="detail-value">{{ formatVerifySignState(currentRow.verifySignState) }}</span>
              </div>
            </el-col>
            <el-col :span="24">
              <div class="detail-item">
                <span class="detail-label">回调URL:</span>
                <span class="detail-value">{{ currentRow.callbackUrl || '-' }}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="detail-item">
                <span class="detail-label">回调时间:</span>
                <span class="detail-value">{{ currentRow.callbackTime || '-' }}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="detail-item">
                <span class="detail-label">完成时间:</span>
                <span class="detail-value">{{ currentRow.finishTime || '-' }}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="detail-item">
                <span class="detail-label">完成状态:</span>
                <span class="detail-value">{{ formatFinishState(currentRow.finishState) }}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="detail-item">
                <span class="detail-label">项目环境:</span>
                <span class="detail-value">{{ currentRow.springProfilesActive || '-' }}</span>
              </div>
            </el-col>
            <el-col :span="24">
              <div class="detail-item">
                <span class="detail-label">处理结果:</span>
                <span class="detail-value">{{ currentRow.finishResult || '-' }}</span>
              </div>
            </el-col>
          </el-row>
        </div>

        <!-- 回调报文 -->
        <div class="detail-section">
          <h3>回调报文</h3>
          <pre class="code-block">{{ formatJson(currentRow.callbackMessage) }}</pre>
        </div>

        <!-- 回调值 -->
        <div class="detail-section">
          <h3>回调值</h3>
          <el-row :gutter="20">
            <el-col v-for="i in 9" :key="i" :span="8">
              <div class="detail-item">
                <span class="detail-label">回调值{{ i }}:</span>
                <span class="detail-value">{{ currentRow['callbackValue' + i] || '-' }}</span>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'ThirdPartyCallRecord',
  data() {
    return {
      // 搜索表单
      searchForm: {
        storeCode: '',
        thirdInterfaceCode: '',
        bizType: '',
        verifySignState: '',
        finishState: '',
        timeRange: []
      },
      // 表格数据
      tableData: [],
      // 分页
      pagination: {
        total: 0,
        pageNo: 1,
        pageSize: 10
      },
      // 详情弹窗
      detailDialogVisible: false,
      currentRow: null,
      // 业务类型列表
      bizTypeList: [],
      // 完成状态列表
      finishStateList: []
    };
  },
  async mounted() {
    this.initDefaultTimeRange();
    await this.queryCallbackLogBizType();
    await this.queryCallbackLogFinishState();
    this.fetchData();
  },
  methods: {
    // 获取列表数据
    async fetchData() {
      try {
        const params = {
          pageNo: this.pagination.pageNo,
          pageSize: this.pagination.pageSize
        };

        // 添加搜索条件
        if (this.searchForm.storeCode) {
          params.storeCode = this.searchForm.storeCode;
        }
        if (this.searchForm.thirdInterfaceCode) {
          params.thirdInterfaceCode = this.searchForm.thirdInterfaceCode;
        }
        if (this.searchForm.bizType) {
          params.bizType = this.searchForm.bizType;
        }
        if (this.searchForm.verifySignState) {
          params.verifySignState = this.searchForm.verifySignState;
        }
        if (this.searchForm.finishState) {
          params.finishState = this.searchForm.finishState;
        }
        if (this.searchForm.timeRange && this.searchForm.timeRange.length === 2) {
          params.startTime = this.searchForm.timeRange[0];
          params.endTime = this.searchForm.timeRange[1];
        }

        const { code, result } = await this.$store.dispatch(
          'thirdCompanyOpenPlatformConfigOperationRecord',
          params
        );

        if (code == 0 || code === '0') {
          this.tableData = result.records || [];
          this.pagination.total = result.total || 0;
        }
      } catch (error) {
        this.$message.error('获取列表数据失败');
        console.error(error);
      }
    },
    // 搜索
    handleSearch() {
      this.pagination.pageNo = 1;
      this.fetchData();
    },
    // 重置
    handleReset() {
      // 保存当前业务类型值
      const currentBizType = this.searchForm.bizType;
      this.searchForm = {
        storeCode: '',
        thirdInterfaceCode: '',
        bizType: currentBizType,
        verifySignState: '',
        finishState: '',
        timeRange: []
      };
      this.initDefaultTimeRange();
      this.pagination.pageNo = 1;
      this.fetchData();
    },
    // 初始化默认时间范围（最近一个月）
    initDefaultTimeRange() {
      const end = new Date();
      const start = new Date();
      start.setMonth(start.getMonth() - 1);
      this.searchForm.timeRange = [
        this.formatDateTime(start),
        this.formatDateTime(end)
      ];
    },
    // 格式化日期时间
    formatDateTime(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    // 分页变化
    handlePageChange(page) {
      this.pagination.pageNo = page;
      this.fetchData();
    },
    // 查看详情
    handleViewDetail(row) {
      this.currentRow = row;
      this.detailDialogVisible = true;
    },
    // 格式化业务类型
    formatBizType(type) {
      const map = {
        'ruleSync': '规则同步',
        'distribute': '发放',
        'usageFeedback': '使用反馈'
      };
      return map[type] || type || '-';
    },
    // 格式化验签状态
    formatVerifySignState(state) {
      const map = {
        'check': '校验中',
        'pass': '通过',
        'fail': '失败'
      };
      return map[state] || state || '-';
    },
    // 获取验签状态标签类型
    getVerifySignStateType(state) {
      const typeMap = {
        'check': 'warning',
        'pass': 'success',
        'fail': 'danger'
      };
      return typeMap[state] || 'info';
    },
    // 格式化完成状态
    formatFinishState(state) {
      const map = {
        'wait': '等待中',
        'processing': '处理中',
        'success': '成功',
        'fail': '失败'
      };
      return map[state] || state || '-';
    },
    // 获取完成状态标签类型
    getFinishStateType(state) {
      const typeMap = {
        'wait': 'info',
        'processing': 'warning',
        'success': 'success',
        'fail': 'danger'
      };
      return typeMap[state] || 'info';
    },
    // 格式化JSON显示
    formatJson(json) {
      if (!json) return '{}';
      try {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        return JSON.stringify(obj, null, 2);
      } catch (e) {
        return json;
      }
    },
    async queryCallbackLogBizType() {
      try {
        const { code, result } = await this.$store.dispatch("queryCallbackLogBizType");
        if (code == 0 || code === '0') {
          this.bizTypeList = result || [];
          // 默认选中第一个
          if (this.bizTypeList.length > 0) {
            this.searchForm.bizType = this.bizTypeList[0].itemValue;
          }
        }
      } catch (error) {
        console.error('获取业务类型失败', error);
      }
    },
    async queryCallbackLogFinishState() {
      try {
        const { code, result } = await this.$store.dispatch("queryCallbackLogFinishState");
        if (code == 0 || code === '0') {
          this.finishStateList = result || [];
        }
      } catch (error) {
        console.error('获取完成状态失败', error);
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.third-party-call-record {
  padding: 20px;

  .container {
    background-color: white;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }

  h1 {
    font-size: 24px;
    margin-bottom: 20px;
    color: #333;
    font-weight: 500;
  }

  .filter-section {
    background-color: #fafafa;
    padding: 15px;
    border-radius: 8px;
    border: 1px solid #e8e8e8;
  }

  .pagination {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
  }

  .detail-content {
    max-height: 60vh;
    overflow-y: auto;
  }

  .detail-section {
    margin-bottom: 20px;

    h3 {
      font-size: 16px;
      font-weight: 600;
      color: #333;
      margin-bottom: 15px;
      padding-bottom: 10px;
      border-bottom: 1px solid #e8e8e8;
    }
  }

  .detail-item {
    margin-bottom: 12px;
    line-height: 1.5;

    .detail-label {
      color: #666;
      font-weight: 500;
      margin-right: 8px;
    }

    .detail-value {
      color: #333;
      word-break: break-all;
    }
  }

  .code-block {
    background-color: #f5f5f5;
    padding: 15px;
    border-radius: 4px;
    font-family: 'Courier New', Courier, monospace;
    font-size: 13px;
    white-space: pre-wrap;
    word-break: break-all;
    max-height: 300px;
    overflow-y: auto;
    margin: 0;
  }
}

::v-deep {
  .el-form-item {
    margin-bottom: 0;
  }
}
</style>
